import { useState, useEffect, useContext } from "react";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { useOutletContext } from "react-router-dom";

export function Help() {
  //const [projectId, setProjectId] = useState("");
  const bookingal_domain = "bookingal.de";
  /*useEffect(() => {
    (async () => {
      const response = await fetch("/api/admin/project_id", {
        credentials: "same-origin",
      });
      if (response.ok) {
        setProjectId(await response.json());
      }
    })();
  }, []);*/
  const { project } = useOutletContext();
  return (
    <>
      <p>
        Um das Buchungsformular zu benutzen, müssen folgende Zeilen in den
        HTML-Code der Seite eingefügt werden:
      </p>
      <ol role="list" className="mt-8 space-y-8 text-gray-600">
        <li className="gap-x-3">
          In den "head"-Abschnitt:
          <div className="flex items-center justify-between text-gray-800 border border-gray-800 bg-white font-mono text-sm py-3 px-4 w-full rounded-md">
            <div className="flex gap-1">
              <code>
                &lt;link href="https://{bookingal_domain}/css/style.css"
                rel="stylesheet" /&gt;
                <br />
                &lt;script src="https://{bookingal_domain}/js/alpine.min.js"
                defer&gt;&lt;/script&gt;
                <br />
                &lt;script src="https://{bookingal_domain}
                /js/bookingal.js"&gt;&lt;/script&gt;
              </code>
            </div>
            <span className="flex text-gray-800 cursor-pointer w-5 h-5 hover:text-gray-400 duration-200"></span>
          </div>
        </li>
        <li className="gap-x-3">
          An der Stelle, wo das Formular eingefügt werden soll:
          <div className="flex items-center justify-between text-gray-800 border border-gray-800 bg-white font-mono text-sm py-3 px-4 w-full rounded-md">
            <div className="flex gap-1">
              <code>&lt;div id="bookingal"&gt;&lt;/div&gt;</code>
            </div>
            <span className="flex text-gray-800 cursor-pointer w-5 h-5 hover:text-gray-400 duration-200"></span>
          </div>
        </li>
        <li className="gap-x-3">
          In den "script"-Abschnitt am Ende der Seite:
          <div className="flex items-center justify-between text-gray-800 border border-gray-800 bg-white font-mono text-sm py-3 px-4 w-full rounded-md">
            <div className="flex gap-1">
              <code>
                const project_id = '{project?.id}'
                <br />
                loadbookingform(project_id)
              </code>
            </div>
            <span className="flex text-gray-800 cursor-pointer w-5 h-5 hover:text-gray-400 duration-200"></span>
          </div>
        </li>
      </ol>
      <div className="rounded-md bg-green-50 p-4 mt-4">
        <div className="flex">
          <div className="shrink-0">
            <CheckCircleIcon
              aria-hidden="true"
              className="size-5 text-green-400"
            />
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-green-800">
              Bei Fragen oder Problemen bin ich unter{" "}
              <a href="mailto:roman.huebert@gmail.com">
                roman.huebert@gmail.com
              </a>{" "}
              oder 0172/1043616 erreichbar.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
